<template>
  <div>
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('accountWithdrawalApplyListManage.accountWithdrawalRecords') }}</div>
      </div>
      <div class="">
        <account-withdrawal-apply-list-table
          :table-data="accountWithdrawalApplyListManageInfo.accountWithdrawalApplyLists" :loading="loading"
          @refresh="handleRefresh" />
        <el-pagination class="pagination-container" background layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.currentPage" :page-size="pagination.pageSize" :total="pagination.total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>
    </el-card>
  </div>
</template>

<script>
import AccountWithdrawalApplyListTable from '@/components/admin/accountWithdrawalApplyListManage/AccountWithdrawalApplyListTable'
import { listStateWithdrawalApplys } from '@/api/admin/accountWithdrawalApplyListManage/accountWithdrawalApplyApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AccountWithdrawalApplyListManage',
  components: {
    AccountWithdrawalApplyListTable
  },
  data() {
    return {
      loading: false,
      shopId: '',
      accountWithdrawalApplyListManageInfo: {
        accountWithdrawalApplyLists: [],
        conditions: {
          state: '486,586,587,686,687'
        }
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.shopId = getShopId()
    this._listAccountWithdrawalApplyLists()
  },
  methods: {
    async _listAccountWithdrawalApplyLists() {
      this.loading = true
      const params = {
        ...this.accountWithdrawalApplyListManageInfo.conditions,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      try {
        const res = await listStateWithdrawalApplys(params)
        this.accountWithdrawalApplyListManageInfo.accountWithdrawalApplyLists = res.data
        this.pagination.total = res.total
      } catch (error) {
        console.error('获取提现申请列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this._listAccountWithdrawalApplyLists()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this._listAccountWithdrawalApplyLists()
    },
    handleRefresh() {
      this._listAccountWithdrawalApplyLists()
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #e7eaec;
  border-radius: 4px;
}

.ibox-title {
  padding: 15px 15px 7px;
  min-height: 48px;
  border-bottom: 1px solid #e7eaec;
}

.ibox-content {
  padding: 15px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>